module.exports = __webpack_public_path__ + "static/media/business-solution-amico-business.6d52076b.svg";